import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PropertyInquiriesCheckIfUserEnquiredRequestDTO,
  PropertyInquiriesCreateRequestDTO,
  PropertyInquiriesDeleteRequestDTO,
  PropertyInquiriesDTO,
  PropertyInquiriesGetEnquiredUserDetailsRequestDTO,
  PropertyInquiriesGetEnquiredUserDetailsResponseList,
  PropertyInquiriesList,
  PropertyInquiriesReadByIdRequestDTO,
  PropertyInquiriesReadByMasterIdRequestDTO,
  PropertyInquiriesReadByOwnerUserIdRequestDTO,
  PropertyInquiriesReadByUserIdRequestDTO,
  PropertyInquiriesUpdateRequestDTO
} from '../property-inquiries/property-inquiries.interface';

import {
  PropertyInquiries_CheckIfUserEnquired,
  PropertyInquiries_Create,
  PropertyInquiries_Delete,
  PropertyInquiries_GetEnquiredUserDetails,
  PropertyInquiries_ReadAll,
  PropertyInquiries_ReadById,
  PropertyInquiries_ReadByMasterId,
  PropertyInquiries_ReadByOwnerUserId,
  PropertyInquiries_ReadByUserId,
  PropertyInquiries_Update
} from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class PropertyInquiriesService {
  constructor(private http: HttpClient) { }

  PropertyInquiries_Create(data: PropertyInquiriesCreateRequestDTO): Observable<PropertyInquiriesDTO> {
    return this.http.post<PropertyInquiriesDTO>(PropertyInquiries_Create, data);
  }

  PropertyInquiries_Update(data: PropertyInquiriesUpdateRequestDTO): Observable<PropertyInquiriesDTO> {
    return this.http.post<PropertyInquiriesDTO>(PropertyInquiries_Update, data);
  }

  PropertyInquiries_Delete(data: PropertyInquiriesDeleteRequestDTO): Observable<any> {
    return this.http.post<any>(PropertyInquiries_Delete, data);
  }

  PropertyInquiries_ReadAll(): Observable<PropertyInquiriesList> {
    return this.http.get<PropertyInquiriesList>(PropertyInquiries_ReadAll);
  }

  PropertyInquiries_ReadById(data: PropertyInquiriesReadByIdRequestDTO): Observable<PropertyInquiriesDTO> {
    return this.http.post<PropertyInquiriesDTO>(PropertyInquiries_ReadById, data);
  }

  PropertyInquiries_ReadByMasterId(data: PropertyInquiriesReadByMasterIdRequestDTO): Observable<PropertyInquiriesList> {
    return this.http.post<PropertyInquiriesList>(PropertyInquiries_ReadByMasterId, data);
  }

  PropertyInquiries_ReadByOwnerUserId(data: PropertyInquiriesReadByOwnerUserIdRequestDTO): Observable<PropertyInquiriesList> {
    return this.http.post<PropertyInquiriesList>(PropertyInquiries_ReadByOwnerUserId, data);
  }

  PropertyInquiries_ReadByUserId(data: PropertyInquiriesReadByUserIdRequestDTO): Observable<PropertyInquiriesList> {
    return this.http.post<PropertyInquiriesList>(PropertyInquiries_ReadByUserId, data);
  }

  PropertyInquiries_CheckIfUserEnquired(data: PropertyInquiriesCheckIfUserEnquiredRequestDTO): Observable<PropertyInquiriesDTO> {
    return this.http.post<PropertyInquiriesDTO>(PropertyInquiries_CheckIfUserEnquired, data);
  }

  PropertyInquiries_GetEnquiredUserDetails(data: PropertyInquiriesGetEnquiredUserDetailsRequestDTO): Observable<PropertyInquiriesGetEnquiredUserDetailsResponseList> {
    return this.http.post<PropertyInquiriesGetEnquiredUserDetailsResponseList>(PropertyInquiries_GetEnquiredUserDetails, data);
  }
}
